<script lang="ts">
	import "@glidejs/glide/dist/css/glide.core.min.css";
	import figurine1ImgSm from "../../assets/images/custom-cakes/figurines/figurine-1.jpg?w=400&webp&imagetools";
	import figurine1ImgMd from "../../assets/images/custom-cakes/figurines/figurine-1.jpg?w=432&webp&imagetools";
	import figurine1ImgLg from "../../assets/images/custom-cakes/figurines/figurine-1.jpg?w=496&webp&imagetools";
	import figurine2ImgSm from "../../assets/images/custom-cakes/figurines/figurine-2.jpg?w=400&webp&imagetools";
	import figurine2ImgMd from "../../assets/images/custom-cakes/figurines/figurine-2.jpg?w=432&webp&imagetools";
	import figurine2ImgLg from "../../assets/images/custom-cakes/figurines/figurine-2.jpg?w=496&webp&imagetools";
	import figurine3ImgSm from "../../assets/images/custom-cakes/figurines/figurine-3.jpg?w=400&webp&imagetools";
	import figurine3ImgMd from "../../assets/images/custom-cakes/figurines/figurine-3.jpg?w=432&webp&imagetools";
	import figurine3ImgLg from "../../assets/images/custom-cakes/figurines/figurine-3.jpg?w=496&webp&imagetools";
	import figurine4ImgSm from "../../assets/images/custom-cakes/figurines/figurine-4.jpg?w=400&webp&imagetools";
	import figurine4ImgMd from "../../assets/images/custom-cakes/figurines/figurine-4.jpg?w=432&webp&imagetools";
	import figurine4ImgLg from "../../assets/images/custom-cakes/figurines/figurine-4.jpg?w=496&webp&imagetools";
	import figurine5ImgSm from "../../assets/images/custom-cakes/figurines/figurine-5.jpg?w=400&webp&imagetools";
	import figurine5ImgMd from "../../assets/images/custom-cakes/figurines/figurine-5.jpg?w=432&webp&imagetools";
	import figurine5ImgLg from "../../assets/images/custom-cakes/figurines/figurine-5.jpg?w=496&webp&imagetools";
	import figurine6ImgSm from "../../assets/images/custom-cakes/figurines/figurine-6.jpg?w=400&webp&imagetools";
	import figurine6ImgMd from "../../assets/images/custom-cakes/figurines/figurine-6.jpg?w=432&webp&imagetools";
	import figurine6ImgLg from "../../assets/images/custom-cakes/figurines/figurine-6.jpg?w=496&webp&imagetools";
	import figurine7ImgSm from "../../assets/images/custom-cakes/figurines/figurine-7.jpg?w=400&webp&imagetools";
	import figurine7ImgMd from "../../assets/images/custom-cakes/figurines/figurine-7.jpg?w=432&webp&imagetools";
	import figurine7ImgLg from "../../assets/images/custom-cakes/figurines/figurine-7.jpg?w=496&webp&imagetools";
	import figurine8ImgSm from "../../assets/images/custom-cakes/figurines/figurine-8.jpg?w=400&webp&imagetools";
	import figurine8ImgMd from "../../assets/images/custom-cakes/figurines/figurine-8.jpg?w=432&webp&imagetools";
	import figurine8ImgLg from "../../assets/images/custom-cakes/figurines/figurine-8.jpg?w=496&webp&imagetools";
	import figurine9ImgSm from "../../assets/images/custom-cakes/figurines/figurine-9.jpg?w=400&webp&imagetools";
	import figurine9ImgMd from "../../assets/images/custom-cakes/figurines/figurine-9.jpg?w=432&webp&imagetools";
	import figurine9ImgLg from "../../assets/images/custom-cakes/figurines/figurine-9.jpg?w=496&webp&imagetools";
	import figurine10ImgLg from "../../assets/images/custom-cakes/figurines/figurine-10.jpg?w=496&webp&imagetools";
	import figurine10ImgSm from "../../assets/images/custom-cakes/figurines/figurine-10.jpg?w=400&webp&imagetools";
	import figurine10ImgMd from "../../assets/images/custom-cakes/figurines/figurine-10.jpg?w=432&webp&imagetools";
	import { nbspify } from "../../../../core/utils/nbspify";
	import Glider from "../Glider.svelte";
	import type { ImageSizes } from "../../../../core/schema/Image";

	const images: ImageSizes[] = [
		{
			sm: figurine1ImgSm,
			md: figurine1ImgMd,
			lg: figurine1ImgLg,
		},
		{
			sm: figurine2ImgSm,
			md: figurine2ImgMd,
			lg: figurine2ImgLg,
		},
		{
			sm: figurine3ImgSm,
			md: figurine3ImgMd,
			lg: figurine3ImgLg,
		},
		{
			sm: figurine4ImgSm,
			md: figurine4ImgMd,
			lg: figurine4ImgLg,
		},
		{
			sm: figurine5ImgSm,
			md: figurine5ImgMd,
			lg: figurine5ImgLg,
		},
		{
			sm: figurine6ImgSm,
			md: figurine6ImgMd,
			lg: figurine6ImgLg,
		},
		{
			sm: figurine7ImgSm,
			md: figurine7ImgMd,
			lg: figurine7ImgLg,
		},
		{
			sm: figurine8ImgSm,
			md: figurine8ImgMd,
			lg: figurine8ImgLg,
		},
		{
			sm: figurine9ImgSm,
			md: figurine9ImgMd,
			lg: figurine9ImgLg,
		},
		{
			sm: figurine10ImgSm,
			md: figurine10ImgMd,
			lg: figurine10ImgLg,
		},
	];
</script>

<div
	class="flex flex-col items-center gap-10 overflow-hidden rounded-3xl border-secondary-200 px-6 py-8 min-[400px]:gap-16 sm:px-10 sm:py-12 md:px-14 md:py-16 lg:flex-row lg:gap-16 lg:p-10 lg:pl-16 lg:pr-10 xl:pl-20 xl:pr-4"
>
	<div class="flex flex-col justify-center text-center lg:basis-[calc(50%-1.5rem)] lg:justify-start lg:text-left">
		<h2 class="decorative-headline !mx-0 !mb-6 lg:!text-left">Figurky</h2>
		<p class="h2 mb-8 !text-lg lg:!text-xl">
			{nbspify("Dodejte narozeninovému dortu jedinečný šmrnc s ručně vyráběnou figurkou!")}
		</p>
		<p class="mb-10">
			{nbspify(
				"Vytvoříme postavičku podle vašich představ - oblíbenou pohádkovou postavu, zvířátko nebo jednoduchý předmět. Modelujeme z cukrové hmoty, která je bezlepková. Výroba nám trvá přibližně týden. Cena jedné figurky je od 450 Kč a není zahrnuta v ceně dortu.",
			)}
		</p>
	</div>
	<Glider firstImageLoading="eager" {images} />
</div>
